import React from 'react';

import { useRefValue } from '@looko-corp/acloset-react-kit/src/react';

type IntersectHandler = (entry: IntersectionObserverEntry, observer: IntersectionObserver) => void;

/**
 * ref가 달려있는 element가 observe된 상태인지 알 수 있게 해주는 hook
 */
export const useIntersect = <T extends HTMLElement>(
  onIntersect: IntersectHandler,
  options?: IntersectionObserverInit,
) => {
  const ref = React.useRef<T>(null);

  const onIntersectRef = useRefValue(onIntersect);

  const callback = React.useCallback(
    (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        onIntersectRef.current(entry, observer);
      }
    },
    [onIntersectRef],
  );

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new IntersectionObserver(callback, options);
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref, options, callback]);

  return ref;
};
